import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { CustomDropdown } from "../../Common/_components/CustomDropdown";
import { buildLicenseModalityOptions, buildLicenseProductOptions } from "./getSellableLicenseTypes";

export function LicenseTypeSelector({ licenseTypes, value, onChange }) {

    //LIBRARIES
    const { t } = useTranslation();

    //LOCAL STATE
    const [product, setProduct] = useState("");

    //VIEW
    const modalities = buildLicenseModalityOptions(licenseTypes, product, t);

    return (
        <div>
            <CustomDropdown
                testid="license-product"
                isSearchable={false}
                options={buildLicenseProductOptions(licenseTypes, t)}
                value={product}
                onChange={handleProductChange}
            />
            {modalities.length > 1 && (
                <>
                    <div className="mt-2" />
                    <div className="font-weight-bold text-uppercase">
                        {t("mod_budgets_license_modality")}
                    </div>
                    <CustomDropdown
                        testid="license-modality"
                        isSearchable={false}
                        options={modalities}
                        value={value}
                        onChange={onChange}
                    />
                </>
            )}
        </div>
    );

    //HANDLERS
    function handleProductChange(newProduct) {
        setProduct(newProduct);
        const options = buildLicenseModalityOptions(licenseTypes, newProduct, t);
        onChange(options.length === 1 ? options[0].value : "");
    }
}
